module.exports = __webpack_public_path__ + "static/img/dbbk.9b757e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/tg_images/dbbk.png
// module id = Fvae
// module chunks = 5